import { render, staticRenderFns } from "./lazyblock_contacts.vue?vue&type=template&id=d5b5cf4a&scoped=true"
import script from "./lazyblock_contacts.vue?vue&type=script&lang=js"
export * from "./lazyblock_contacts.vue?vue&type=script&lang=js"
import style0 from "./lazyblock_contacts.vue?vue&type=style&index=0&id=d5b5cf4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b5cf4a",
  null
  
)

export default component.exports